import React, { Component } from 'react';
import axios from 'axios';
import HOC from './HOC';
import ReactHtmlParser from 'react-html-parser';
import apiUrl from './base_url';
import logo from './img/erwatodaylogo.png';
import '../components/cssfile/payment.css';

class Payment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      discount: 0,
      isDiscounted: false,
      payment: [],
      email: '',
      regid: '',
      phone: '',
      key: 'rzp_live_AQkJ7i0IS8F2nj',
      checked: false,
      isLoading: true,
      isPaying: false,
      error: '',
    };
  }

  componentDidMount() {
    const email = localStorage.getItem('email');
    const regid = localStorage.getItem('regid');

    if (!email || !regid) {
      this.props.history.push('/login');
      return;
    }

    this.setState({
      email,
      regid,
    });

    this.loadPaymentData();
    this.loadRazorpay();
  }

  componentWillUnmount() {
    if (this.razorpayScript && this.razorpayScript.parentNode) {
      this.razorpayScript.parentNode.removeChild(this.razorpayScript);
    }
  }

  loadPaymentData = () => {
    axios
      .get(apiUrl + 'serverside/payment.php')
      .then(response => {
        this.setState({
          payment: Array.isArray(response.data)
            ? response.data
            : [],
          isLoading: false,
        });
      })
      .catch(error => {
        console.error(error);

        this.setState({
          isLoading: false,
          error: 'Unable to load payment information. Please try again.',
        });
      });
  };

  loadRazorpay = () => {
    if (window.Razorpay) {
      return;
    }

    this.razorpayScript = document.createElement('script');

    this.razorpayScript.src =
      'https://checkout.razorpay.com/v1/checkout.js';

    this.razorpayScript.async = true;

    this.razorpayScript.onload = () => {
      console.log('Razorpay library loaded');
    };

    this.razorpayScript.onerror = () => {
      console.error('Unable to load Razorpay');
    };

    document.body.appendChild(this.razorpayScript);
  };

  handleCheckboxToggle = event => {
    this.setState({
      checked: event.target.checked,
    });
  };

  handleApplyDiscount = discount => {
    this.setState({
      discount: Number(discount) || 0,
      isDiscounted: true,
    });
  };

  getTotalAmount = () => {
    const { payment, discount, isDiscounted } = this.state;

    const originalAmount = payment.reduce(
      (total, item) => total + Number(item.amount || 0),
      0
    );

    if (isDiscounted) {
      return originalAmount - (originalAmount * discount) / 100;
    }

    return originalAmount;
  };

  getOriginalAmount = () => {
    return this.state.payment.reduce(
      (total, item) => total + Number(item.amount || 0),
      0
    );
  };

  handlePayment = () => {
    const {
      payment,
      key,
      checked,
      discount,
      isDiscounted,
      email,
      regid,
    } = this.state;

    if (!checked) {
      alert(
        'Please check the Payment Privacy and Policy checkbox.'
      );
      return;
    }

    if (!payment.length) {
      alert('Payment information is not available.');
      return;
    }

    if (!window.Razorpay) {
      alert(
        'Payment service is still loading. Please try again.'
      );
      return;
    }

    const originalAmount = payment.reduce(
      (total, item) => total + Number(item.amount || 0),
      0
    );

    const finalAmount = isDiscounted
      ? originalAmount -
        (originalAmount * Number(discount || 0)) / 100
      : originalAmount;

    const amountInPaise = Math.round(finalAmount * 100);

    this.setState({
      isPaying: true,
    });

    const options = {
      key: key,

      amount: amountInPaise,

      currency: 'INR',

      name: 'ErwaToday',

      image: logo,

      description: 'ErwaToday Test Series',

      prefill: {
        email: email,
      },

      notes: {
        regid: regid,
      },

      theme: {
        color: '#2563eb',
      },

      handler: response => {
        const data = {
          payment_id: response.razorpay_payment_id,
          amount: finalAmount,
          email: email,
          regid: regid,
        };

        axios
          .post(
            apiUrl + 'serverside/user_payment.php',
            data
          )
          .then(responseData => {
            console.log(responseData.data);

            alert(responseData.data);

            this.props.history.push('/dashboard');
          })
          .catch(error => {
            console.error(error);

            this.setState({
              isPaying: false,
            });

            alert(
              'Payment was completed, but we could not update your account. Please contact support.'
            );
          });
      },

      modal: {
        ondismiss: () => {
          this.setState({
            isPaying: false,
          });
        },
      },
    };

    try {
      const razorpay = new window.Razorpay(options);

      razorpay.on(
        'payment.failed',
        response => {
          console.error(
            'Payment failed:',
            response.error
          );

          this.setState({
            isPaying: false,
          });

          alert(
            response.error?.description ||
              'Payment failed. Please try again.'
          );
        }
      );

      razorpay.open();
    } catch (error) {
      console.error(error);

      this.setState({
        isPaying: false,
      });

      alert(
        'Unable to start payment. Please try again.'
      );
    }
  };

  render() {
    const {
      payment,
      checked,
      isDiscounted,
      discount,
      isLoading,
      isPaying,
      error,
    } = this.state;

    const originalAmount = this.getOriginalAmount();
    const finalAmount = this.getTotalAmount();

    return (
      <div className="et-payment-page">

        {/* ================= HEADER ================= */}

        <div className="et-payment-header">

          <div className="et-payment-brand">

            <div className="et-payment-logo">
              <img
                src={logo}
                alt="ErwaToday"
              />
            </div>

            <div>
              <strong>ErwaToday</strong>
              <span>Secure Payment</span>
            </div>

          </div>

          <div className="et-secure-badge">
            <span>🔒</span>
            Secure Checkout
          </div>

        </div>


        {/* ================= MAIN ================= */}

        <main className="et-payment-container">

          {/* PAGE TITLE */}

          <div className="et-payment-title">

            <span className="et-payment-eyebrow">
              PAYMENT
            </span>

            <h1>
              Complete Your Purchase
            </h1>

            <p>
              Review the payment details below and
              continue securely with Razorpay.
            </p>

          </div>


          {isLoading ? (

            <div className="et-payment-loading">

              <div className="et-payment-spinner" />

              <strong>
                Loading payment details...
              </strong>

              <span>
                Please wait a moment.
              </span>

            </div>

          ) : error ? (

            <div className="et-payment-error">

              <div className="et-payment-error-icon">
                !
              </div>

              <h3>
                Unable to load payment details
              </h3>

              <p>
                {error}
              </p>

              <button
                type="button"
                onClick={this.loadPaymentData}
              >
                Try Again
              </button>

            </div>

          ) : (

            <div className="et-payment-grid">

              {/* ================= POLICY ================= */}

              <section className="et-payment-policy-card">

                <div className="et-card-heading">

                  <div className="et-card-icon">
                    ✓
                  </div>

                  <div>
                    <span>
                      BEFORE YOU PAY
                    </span>

                    <h2>
                      Payment Privacy & Policy
                    </h2>
                  </div>

                </div>


                <div className="et-policy-content">

                  {payment.length > 0 ? (

                    payment.map((item, index) => (

                      <div
                        key={item.id || index}
                        className="et-policy-item"
                      >
                        {ReactHtmlParser(item.des)}
                      </div>

                    ))

                  ) : (

                    <div className="et-empty-payment">
                      Payment information is unavailable.
                    </div>

                  )}

                </div>


                {/* AGREEMENT */}

                <label className="et-policy-checkbox">

                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={this.handleCheckboxToggle}
                  />

                  <span className="et-custom-checkbox">
                    {checked && '✓'}
                  </span>

                  <span className="et-checkbox-text">
                    I have read and agree to the
                    <strong>
                      {' '}
                      Payment Privacy and Policy
                    </strong>
                    .
                  </span>

                </label>

                <div className="et-policy-note">
                  Please carefully review the payment
                  privacy and policy before proceeding.
                </div>

              </section>


              {/* ================= ORDER SUMMARY ================= */}

              <aside className="et-payment-summary">

                <div className="et-summary-heading">

                  <span>
                    ORDER SUMMARY
                  </span>

                  <h2>
                    Payment Details
                  </h2>

                </div>


                {/* PRICE */}

                <div className="et-price-section">

                  <span className="et-price-label">
                    Total Amount
                  </span>

                  <div className="et-price">

                    <span>
                      ₹
                    </span>

                    {finalAmount.toFixed(2)}

                  </div>

                  {isDiscounted && (
                    <div className="et-discount-applied">

                      <span>
                        Discount Applied
                      </span>

                      <strong>
                        {discount}%
                      </strong>

                    </div>
                  )}

                </div>


                {/* DETAILS */}

                <div className="et-payment-details">

                  <div className="et-detail-row">

                    <span>
                      Original Amount
                    </span>

                    <strong>
                      ₹{originalAmount.toFixed(2)}
                    </strong>

                  </div>


                  {isDiscounted && (

                    <div className="et-detail-row discount">

                      <span>
                        Discount
                      </span>

                      <strong>
                        -₹
                        {(
                          originalAmount -
                          finalAmount
                        ).toFixed(2)}
                      </strong>

                    </div>

                  )}


                  {payment.map((item, index) => (

                    <React.Fragment
                      key={item.id || index}
                    >

                      {item.validity && (

                        <div className="et-detail-row">

                          <span>
                            Validity
                          </span>

                          <strong>
                            {ReactHtmlParser(
                              String(item.validity)
                            )}
                          </strong>

                        </div>

                      )}

                    </React.Fragment>

                  ))}

                </div>


                {/* DISCOUNT */}

                {payment.some(
                  item => Number(item.discount) > 0
                ) && (

                  <div className="et-discount-box">

                    <div>

                      <strong>
                        Special Discount
                      </strong>

                      <span>
                        Save more on your purchase
                      </span>

                    </div>


                    <button
                      type="button"
                      onClick={() =>
                        this.handleApplyDiscount(
                          payment[0].discount
                        )
                      }
                      disabled={isDiscounted}
                    >
                      {isDiscounted
                        ? 'Applied'
                        : `Apply ${
                            payment[0].discount
                          }%`}
                    </button>

                  </div>

                )}


                {/* PAY BUTTON */}

                <button
                  type="button"
                  className={`et-pay-button ${
                    isPaying ? 'loading' : ''
                  }`}
                  onClick={this.handlePayment}
                  disabled={isPaying || !checked}
                >

                  {isPaying ? (

                    <>
                      <span className="et-button-spinner" />
                      Processing Payment...
                    </>

                  ) : (

                    <>
                      <span>
                        Pay ₹{finalAmount.toFixed(2)}
                      </span>

                      <span className="et-pay-arrow">
                        →
                      </span>
                    </>

                  )}

                </button>


                <div className="et-secure-payment-note">

                  <span>
                    🔒
                  </span>

                  Secure payment powered by Razorpay

                </div>

              </aside>

            </div>

          )}

        </main>


        {/* ================= FOOTER ================= */}

        <div className="et-payment-footer">

          <span>
            © ErwaToday
          </span>

          <span>
            Secure • Private • Reliable
          </span>

        </div>

      </div>
    );
  }
}

export default HOC(Payment);